var _g, _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnreadBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unread-bell_svg__clip0_1_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.134 22.419c-.869.032-1.77 0-2.64 0H9.757c-.193 0-.354 0-.29.257.097.612.258 1.16.677 1.642.87.966 1.9 1.353 3.155.999 1.224-.355 1.932-1.192 2.158-2.48.064-.29.032-.418-.323-.418zm7.406-4.154c-1.545-1.578-2.254-3.477-2.447-5.635-.064-.805-.032-1.578-.129-2.383-.418-3.058-2.093-5.087-4.958-6.182-.322-.128-.74-.128-.934-.322-.225-.225-.032-.676-.097-.998v-.032c-.064-.74-.611-1.32-1.352-1.385-.708-.064-1.352.355-1.61 1.063-.097.322-.097.644-.064.966.032.354-.13.483-.451.58-2.77.805-4.605 2.575-5.377 5.409-.29 1.095-.193 2.19-.29 3.284-.161 2.19-.87 4.154-2.48 5.7a1.43 1.43 0 00-.418.998c-.032.901.644 1.577 1.61 1.577h17.742c.193 0 .386 0 .58-.032 1.255-.29 1.609-1.674.675-2.608zm-17.387.354c.29-.483.58-.933.805-1.384.708-1.353.966-2.834 1.159-4.347.129-1.03-.032-2.093.225-3.123 1.03-3.832 5.667-5.281 8.598-2.64 1.19 1.094 1.803 2.414 1.803 4.024 0 1.835.257 3.606.901 5.345.226.612.58 1.192.934 1.739.064.129.129.225.225.386H5.153z",
    fill: "currentColor"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 5.5,
    r: 4.5,
    fill: "#DF376B",
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unread-bell_svg__clip0_1_10"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 1)",
    d: "M0 0h25v24.768H0z"
  })))));
}

export default SvgUnreadBell;